import { render, staticRenderFns } from "./MFormBranchFullModal.vue?vue&type=template&id=81afd3b8&scoped=true"
import script from "./MFormBranchFullModal.vue?vue&type=script&lang=js"
export * from "./MFormBranchFullModal.vue?vue&type=script&lang=js"
import style0 from "./MFormBranchFullModal.vue?vue&type=style&index=0&id=81afd3b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81afd3b8",
  null
  
)

export default component.exports